import TableBase from './TableBase'

export default TableBase
